import { api, stringifyBody } from '@whitesharx/starfall-frontend-core';
import { AnalyzLimitRequestRespones } from './getLimits';

export type AnalyzLimitRequestOptions = Partial<AnalyzLimitRequestRespones>;

export const startAnalysisRequest = (options: AnalyzLimitRequestOptions) =>
  api.v1.put('analysis', stringifyBody(options)) as Promise<AnalyzLimitRequestRespones>;
